(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["products"] && !window.DesignMode) return;
  try {
    
    //ソート
    let parameters = {};
        if (location.search.length) {
        let keyValue = "";
        let couples = location.search.substr(1).split('&');
        for (let i = 0; i < couples.length; i++) {
        keyValue = couples[i].split('=');
        if (keyValue.length > 1) {
            parameters[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
        }
    }
    const selectElement = document.querySelector("#SortBy");
    selectElement.addEventListener("change", function(event) {
        parameters.sort_by = event.target.value;
        const url = Object.keys(parameters).map(function(key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key])
        }).join('&');
        location.search = url;
    });


    document.addEventListener('DOMContentLoaded', function() {
        const url = window.location.href;
        const items = document.querySelectorAll('.thumn-box');

        let targetUrl = '';

        // URLに基づいてターゲットURLを設定
        if (url.includes('/collections/andagi')) {
            targetUrl = '/collections/andagi/';
        } else if (url.includes('/collections/chinsukou')) {
            targetUrl = '/collections/chinsukou/';
        } else if (url.includes('/collections/brown-sugar')) {
            targetUrl = '/collections/brown-sugar/';
        } else if (url.includes('/collections/gift')) {
            targetUrl = '/collections/gift/';
        } else if (url.includes('/collections/favorite')) {
            targetUrl = '/collections/favorite/';
        } else if (url.includes('/collections/other')) {
            targetUrl = '/collections/other/';
        }

        items.forEach(function(item) {
            const link = item.querySelector('a');
            if (link && link.getAttribute('href') === targetUrl) {
            link.classList.add('highlight');
            }
        });
    });

  } catch(e) { console.error(e); }
})();
      })();
